import * as Sentry from "@sentry/vue";
import { withScope } from "@sentry/vue";
import type { Router } from "vue-router";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin({
    parallel: true,
    setup: (nuxtApp) => {
        if (import.meta.dev) {
            return;
        }

        Sentry.init({
            app: nuxtApp.vueApp,
            dsn: nuxtApp.$config.public.SENTRY_DSN,
            // release: nuxtApp.$config.public.SENTRY_RELEASE,
            // environment: nuxtApp.$config.public.SENTRY_ENVIRONMENT,
            tracePropagationTargets: ["https://m.triya.ru/", "https://www.triya.ru/"],
            integrations: [
                Sentry.browserTracingIntegration({
                    router: nuxtApp.$router as Router,
                    routeLabel: "path",
                }),
                Sentry.httpClientIntegration(),
                Sentry.browserSessionIntegration(),
                Sentry.vueIntegration({
                    tracingOptions: {
                        trackComponents: true,
                        hooks: ["activate", "create", "destroy", "mount", "update"],
                    }
                }),
                Sentry.reportingObserverIntegration(),
                // new Sentry.Replay({
                //     networkDetailAllowUrls: [
                //         `https//${nuxtApp.$config.public.HOST_NAME}`,
                //     ],
                // }),
                // new ReportingObserverIntegration(),
            ],
            
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1,
        });

        nuxtApp.vueApp.config.errorHandler = (err, context) => {
            withScope((scope) => {
                scope.setExtra("context", context);
                Sentry.captureException(err);
            });
        };

        nuxtApp.hook("app:error", (err) => {
            Sentry.captureException(err);
        });

        return {
            provide: {
                sentrySetContext: Sentry.setContext,
                sentrySetUser: Sentry.setUser,
                sentrySetTag: Sentry.setTag,
                sentryAddBreadcrumb: Sentry.addBreadcrumb,
                sentryCaptureException: Sentry.captureException,
            },
        };
    },
});
